<template>
  <div v-if="!isMobile && !hiddenHeadeTop" class="sf-header__navigations desktop" :style="bgColor">

    <SfHeaderNavigationItem v-if="headerList && headerList.length == 0" v-for="(category, index) in catList" :key="index"
      v-e2e="`app-header-url_${category.catId}`" :label="category.name"
      :link="localePath(`/c/${category.catId}/${categoryGetters.getSlug(category)}`)" @click="$emit('back')" class="nav-item" />
    <SfHeaderNavigationItem v-if="headerList&&headerList.length" v-for="(header, index) in headerList" :key="index"
      v-e2e="`app-header-url_${index}`" :label="header.title" :link="header.link" @click="$emit('back')"
      class="nav-item" />
  </div>
  <SfModal v-else :visible="isMobileMenuOpen" class="mobileModal">
    <div class="sf-header__navigation__mobile">
      <SfHeaderNavigationItem v-for="(category, index) in catList" :key="index" v-e2e="`app-header-url_${category}`"
        class="nav-item">
        <template #mobile-navigation-item>
          <div @click="toggleMobileMenu">
            <SfMenuItem :label="category.name" :link="localePath(`/c/${category.catId}/${categoryGetters.getSlug(category)}`)"
              @click="$emit('back')" class="sf-header-navigation-item__menu-item" />
          </div>
        </template>
      </SfHeaderNavigationItem>
    </div>
  </SfModal>
</template>

<script>
import { SfMenuItem, SfModal } from "@storefront-ui/vue";
import { useUiState } from "~/composables";
import { useCategoryTree,categoryGetters } from "@bee-hole/coms";
import { onSSR } from "@vue-storefront/core";
import { computed } from "@nuxtjs/composition-api";
import {
  VSF_LOCALE_COOKIE
} from '@vue-storefront/core';
import { hexToRGBA } from '@/plugins/utils';
export default {
  name: "HeaderNavigation",
  components: {
    SfMenuItem,
    SfModal
  },
  setup(props, context) {
    // console.log('context', context)
    const { isMobileMenuOpen, toggleMobileMenu, isMobile } = useUiState();
    // const { categories, search: searchCat } = useCategory("categories");
    const { catTreeGet, catTrees, loading: catLoading } = useCategoryTree("header_cat");
    const hiddenHeadeTop = computed(() => {
      return context?.root?.$options?.$mallConfig?.mall_web_config?.hiddenHeadeTop || false;
    });
    const bgColor = computed(() => {
      const config = context?.root?.$options?.$mallConfig?.mall_home_artice;
      // js #fff 转成rgba
      if (context?.root?.$options?.$storeConfig?.mall_home_type === 'website') {
        // js #fff 转成rgba
        if (config?.headerBgColor?.indexOf('rgb') !== -1 && config?.headerBgColor?.indexOf('rgb') !== undefined) {
          return { background: ((config?.headerBgColor || '#ffffff')) };
        } else {
          return { background: (hexToRGBA(config?.headerBgColor || '#ffffff', 0.5)) };
        }
      } else {
        return {};
      }
    });
    const headerList = computed(() => {
      const topLinks = [];
      context?.root?.$options?.$mallConfig?.mall_web_config?.headeTop?.map((item) => {
        const newItem = {
          title: item?.title
        };
        if (item.title) {
          if (item?.link?.indexOf('http') === -1) {
            if (process.client) {
              newItem.link = context?.root?.localePath(item.link);
            } else {
              const locale = context?.root?.$cookies.get(VSF_LOCALE_COOKIE);
              newItem.link = (locale !== 'en-US' ? '/' + locale : '') + item.link;
            }
          } else {
            newItem.link = item.link;
          }
          topLinks.push(newItem);
        }
      });
      return topLinks || [];
    });
    onSSR(async () => {
      await catTreeGet({});
    });
    return {
      catList: computed(() => {
        var list = [];
        if (catTrees?.value) {
          let strnum = 0;
          catTrees?.value.map((cat, index) => {
            if (isMobile.value) {
              strnum += cat?.name?.length;
              list.push(cat);
            } else if (index < 4 && strnum < 50) {
              strnum += cat?.name?.length;
              list.push(cat);
            }
          });
        }
        if (list.length) {
          list.push({ name: context.root?.$root?.$t("more"), catId: 0, slug: "all" });
        }
        return list;
      }),
      // categories,
      isMobileMenuOpen,
      toggleMobileMenu,
      isMobile,
      headerList,
      hiddenHeadeTop,
      bgColor,
      categoryGetters
    };
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
  .sf-header__navigation {
    display: flex;
    --header-navigation-margin: 0 0 0 0;
    order: 0;
    flex: 0 0 1;
  }

  @media (min-width: 1024px) {
    .sf-header-navigation-item {
      --header-navigation-item-flex: auto;
      --header-navigation-item-position: static;
    }
  }
}

.sf-header__navigations {
  display: flex;
  --header-navigation-margin: 0 0 0 0;
  order: 0;
  flex: 0 0 auto;

  ::v-deep .sf-header-navigation-item__item--mobile {
    display: none;
  }
}

.sf-header__navigation__mobile {
  margin-right: 32px;

  .sf-header-navigation-item {
    ::v-deep &__item--mobile {
      display: block;
    }
  }
}

.sf-modal {
  ::v-deep &__bar {
    display: none;
  }

  ::v-deep &__content {
    padding: var(--modal-content-padding, var(--spacer-base) 0);
  }
}
</style>
<style lang="scss">
.mobileModal {
  .sf-modal__overlay {
    z-index: 999999;
  }

  .sf-header__navigation__mobile {
    padding-bottom: calc(var(--spacer-xs) + 3.75rem);
  }

  .sf-modal__container {
    z-index: 999999;
  }
}
@include for-desktop{
  .sf-header__navigations {
      border-radius: 15px !important;
      overflow: hidden;
      .sf-header-navigation-item__item--desktop>*:not(.sf-mega-menu) {
        padding: 0 var(--spacer-sm);
        height:32px;
        display: flex;
        align-content: center;
      }
    }
}
.nav-item{
  .sf-header-navigation-item__link{
    text-transform: none !important;
  }
}
</style>
